import React from 'react';
import classNames from 'classnames';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const useStyles = buildUseStyles('UserFeedbackCompleted', (() => ({
  root: { },
})));

const UserFeedbackCompleted = ({ className }) => {
  const classes = useStyles();
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Text
        text={'Thanks for your feedback!'}
        color={'primaryGray'}
      />
      <CheckCircleIcon color={'secondary'} />
    </Box>
  );
};

UserFeedbackCompleted.defaultProps = {
  className: '',
};

UserFeedbackCompleted.propTypes = {
  className: PropTypes.string,
};

export default UserFeedbackCompleted;
